import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Product } from '../../classes/product';

@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss'],
})
export class ProductCategoriesComponent implements OnInit {
  products: Product[];

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.getProducts();
  }

  getProducts() {
    this.activatedRoute.data.subscribe((response) => {
      this.products = response.products;
    });
  }
}
